/* ===========================================================================
   The Rich Beard · Portada.
   Reveal por scroll (Reveal.tsx): IntersectionObserver con el mismo margen
   (-8 % abajo, umbral 0,05) y un seguro a 2,5 s para que nada se quede
   invisible si el observador no dispara. Se carga una vez por sección: se
   inicializa una sola vez y se repite al recargar una sección en el editor.
=========================================================================== */
(function () {
  if (window.__trbHm) return;
  window.__trbHm = true;
  document.documentElement.classList.add('trb-hm-js');

  function reveal(root) {
    var items = (root || document).querySelectorAll('.trb-hm-rv:not(.is-in)');
    if (!items.length) return;
    var show = function (el) { el.classList.add('is-in'); };
    if (!('IntersectionObserver' in window)) { items.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) {
      io.observe(el);
      setTimeout(function () { show(el); }, 2500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
